module.exports = __webpack_public_path__ + "static/media/Clientes.60bbe703.svg";